<div class="container">
  <select style="border: solid 1px black;" #selectElement (change)="getMonthlySoldQtyOfItem(selectElement.value)">
    <option *ngFor="let item of uniqueItemList" [value]="item" >{{item}}</option>
  </select>
</div>
<div id="productSalesGraph"></div>
